import { useQuery } from "@tanstack/react-query";
import { api } from "../api/http";
import { useStore } from "../store/useStore";

/**
 * Darf die Person das Admin-Panel öffnen? Globale Admins immer, sonst wer
 * mindestens ein Projekt verwaltet (Projektverwaltung, Issues #125/#129).
 * `bereit` ist false, solange die Projektliste noch lädt.
 */
export function useVerwaltet(): { darf: boolean; bereit: boolean } {
  const auth = useStore((s) => s.auth);
  const admin = auth?.role === "admin";
  const q = useQuery({ queryKey: ["projects"], queryFn: () => api.projects.list(), enabled: !!auth && !admin, staleTime: 60_000 });
  if (admin) return { darf: true, bereit: true };
  return { darf: (q.data ?? []).some((p) => p.verwaltung), bereit: !auth || !q.isLoading };
}
